/**
 * https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
 * declare here antd variables and additional variables
 *
 * antd variables should be declared in camel case,
 * it will be formatted in kebab case and used in less loader to overwrite antd styles
 *
 * !!!
 * Please, use full color codes (i.e. #eeeeee instead of #eee).
 * And don't use less variables as values (like `inputHoverBorderColor: 'primaryColor'`).
 * Otherwise ColorHelper will not work properly.
 * !!!
 */

export enum Colors {
  PrimaryColor = '#FCC425',
  PrimaryColorHover = '#FFD150',
  Black = '#0D0D0D',
  White = '#FFFFFF',
  DarkGrey = '#5F5F5F',
  LightGrey = '#9E9E9E',
  DisabledColor = '#E3E4E4',
  BackgroundColor = '#EFF3F5',
  DarkBlue = '#193FAC',
  Blue = '#007FFF',
  BlueHover = '#379BFF',
  LightBlue = '#99CAFB',
  WarningColor = '#F6911A',
  WarningColorHover = '#FFB156',
  WarningColorDisabled = '#F0D4A2',
  WarningColorTransparent = '#FCC42534',
  ErrorColor = '#FF4141',
  ErrorColorHover = '#FF6161',
  ErrorColorDisabled = '#F2A6A6',
  ErrorLight = '#FFDADA',
  Green = '#68D656',
  SuccessColor = '#18AA00',
  SuccessColorHover = '#81D972',
  SuccessLight = '#DBFFD5',
  SuccessColorDisables = '#BAE5B3',
  Transparent = 'transparent',
}

export enum FontFamilies {
  FontPrimary = 'Cabin, sans-serif',
  FontSecondary = 'aesthet-nova, sans-serif',
}

export enum FontSizes {
  FontXXS = 10,
  FontXS = 12,
  FontSM = 14,
  FontMD = 16,
  FontLG = 20,
  FontXL = 24,
  FontXXL = 32,
}

export enum Spacing {
  SpacingXXS = 4,
  SpacingXS = 8,
  SpacingSM = 12,
  SpacingMD = 14,
  SpacingLG = 16,
  SpacingXL = 32,
  SpacingXXL = 40,
  SpacingXXXL = 64,
}

export enum Screens {
  ScreensXXXL = '1920px',
  ScreensXXL = '1420px',
  ScreensXL = '1199px',
  ScreensLG = '991px',
  ScreensMD = '767px',
  ScreensSMM = '675px',
  ScreensSM = '575px',
  ScreensXS = '479px',
}

export enum FontWeights {
  Light = 300,
  Regular = 400,
  Medium = 500,
  SemiBold = 600,
  Bold = 700,
}

export enum LineHeights {
  ExtraShort = '1',
  Short = '1.25',
  Tall = '1.28',
  MediumTall = '1.5',
  ExtraTall = '1.7',
}

export enum BorderRadius {
  RadiusXXXS = 2,
  RadiusXXS = 4,
  RadiusXS = 8,
  RadiusSM = 12,
  RadiusMD = 16,
  RadiusLG = 22,
  RadiusXL = 48,
}

export enum Sizes {
  HeightBase = 40,
  HeightSmall = 20,
}

export enum Gradients {
  Primary = 'linear-gradient(6.63deg, #602DD3 44.41%, #9A49FF 93.14%)',
}

export const fontSizes = [
  FontSizes.FontXXL,
  FontSizes.FontXL,
  FontSizes.FontLG,

  FontSizes.FontMD,
  FontSizes.FontSM,
  FontSizes.FontXS,
  FontSizes.FontXXS,
];
